import {
  AfterViewInit,
  Component,
  DoCheck,
  ElementRef,
  HostListener,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import {
  ApiService,
  EventEmitterService,
  MatDialogUtilsService,
  UtilsService,
} from "src/app/shared/services";
import {
  BreakpointObserver,
  Breakpoints,
  BreakpointState,
} from "@angular/cdk/layout";
import { Observable, Subscription } from "rxjs";
import { EnvService } from "../../../shared/services/env.service";
import { ActivatedRoute, Router } from "@angular/router"; 
import { 
  IProductsPayload,
} from "src/app/shared/models"; 
import { Location } from "@angular/common"; 
import { MatSnackBar } from "@angular/material/snack-bar";
import { SCROLL_ICON_SHOW_DURATION } from "src/app/shared/constants";
import { MatDialog } from "@angular/material/dialog";
import { NgxMasonryComponent } from "ngx-masonry";

@Component({
  selector: 'app-customer-favorites',
  templateUrl: './customer-favorites.component.html',
  styleUrls: ['./customer-favorites.component.less']
})
export class CustomerFavoritesComponent implements OnInit {
 interval: ReturnType<typeof setInterval> | undefined;
  isFetched = false;
  isUpdating = false;
  spinner = "assets/image/spinner.gif";
 

  page: number = 0;
  sorting: { sortBy: string; direction: any } = {
    sortBy: "",
    direction: "",
  };
  sortBy: string = "";
  sortType: string = "";
  currentResponseLength: number = 0;

  bpObserver: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Handset
  );
  bpSubscription: Subscription;
  isHandset = false;
  slideIndex = 0;
 
  showBottomPanel = true;
    
  totalCount = 0;
  
 
  public Math: Math = Math;
  throttle = 700;
  scrollDistance = 1;
  scrollUpDistance = 2;
  gridView = true;
  allItems = true;

  @ViewChild('mySidenav') mySidenav: ElementRef;
  filterErr: string;
  noProducts: boolean;

  private originalOffsetTop!: number;
  private isFixed = true;

  @ViewChild("pdReqDialog") pdReqDialog: TemplateRef<any>;
  urls = '';
  status: { type: 'success' | 'error', message: string } | null = null;
  pageWidth: number;
  totalProducts: number;
  @ViewChild(NgxMasonryComponent) masonry: NgxMasonryComponent;
  productListings: any[];
  productsLoading: boolean;
  height: number;
  width: number;
  assetBaseUrl: string;
  projectOptions: any[]=[];
  
  productInfo: any;
  isVariationCallLoading: boolean;
  isVariationExist: boolean;
  variations: any;
  hasSelection: any;
  newVariationFound: boolean;
  paramSku: string;
  loadDetails = false;
    dummyProductListings: any[] = [
    {
      displayable: true,
      main_image: '',
      height: '300px'
    },
    {
      displayable: true,
      main_image: '',
      height: '350px'

    },
    {
      displayable: true,
      main_image: '',
      height: '200px'

    },
    {
      displayable: true,
      main_image: '',
      height: '250px'
    }, {
      displayable: true,
      main_image: '',
      height: '300px'
    },
    {
      displayable: true,
      main_image: '',
      height: '400px'

    },
    {
      displayable: true,
      main_image: '',
      height: '200px'

    },
    {
      displayable: true,
      main_image: '',
      height: '280px'
    },
  ];
  productDetails: any;

  constructor(
    public api: ApiService,
    private breakpointObserver: BreakpointObserver,
    public env: EnvService,
    private router: Router,
    private location: Location,
    public utils: UtilsService,
    private activeRoute: ActivatedRoute,
    private eventEmitterService: EventEmitterService,
    private matDiaService: MatDialogUtilsService,
    private matSnackbar: MatSnackBar,
    private dialog: MatDialog
  ) { 
    this.productListings = this.dummyProductListings;

    this.bpSubscription = this.bpObserver.subscribe(
      (handset: BreakpointState) => {
        this.isHandset = handset.matches;
      }
    );
    this.pageWidth = document.body.clientWidth;
  }
 

  ngAfterViewInit() {
    this.hideIntercomIcon()

    const filterBar = document.getElementById('filterBar');
    if (filterBar) {
      this.originalOffsetTop = filterBar.offsetTop;
      this.onWindowScroll()
    }
  }
  topPosToStartShowing = 300;
  fixFilterBar = 150;
  isIconShow = false;
  showBar = false;
  timeout: any;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const filterBar = document.getElementById('filterBar');
    if (!filterBar) return;

    const scrollPosition = window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    if (scrollPosition >= this.originalOffsetTop && !this.isFixed) {
      filterBar.style.position = 'fixed';
      filterBar.style.top = '0';
      filterBar.style.width = this.api.isAdminSidePanelOpened ? (this.pageWidth - 200) + 'px' : this.pageWidth + 50 + 'px';
      filterBar.style.background = '#fff';
      filterBar.style.zIndex = '1';
      filterBar.style.marginTop = '0px';

      filterBar.style.padding = '12px 0px';
      this.isFixed = true;
    } else if (scrollPosition < this.originalOffsetTop && this.isFixed) {
      filterBar.style.position = 'static';
      filterBar.style.marginTop = '0px';

      this.isFixed = false;
    }

    this.isIconShow = scrollPosition >= this.topPosToStartShowing;
    this.showBar = scrollPosition >= this.fixFilterBar;
    const self = this;
    if (this.isIconShow) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        self.isIconShow = false;
      }, SCROLL_ICON_SHOW_DURATION);
    }
  }

  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }
  

  getWishList() { 
    this.productsLoading = true;
    this.totalProducts = -1;

    this.location.replaceState(
      window.location.pathname,
      "",
      this.location.getState()
    );

    this.api.getWishlistProducts(false).subscribe((payload: IProductsPayload) => {
      if(payload?.products?.length>0){
        this.totalProducts = payload.products.length;
        payload.products.forEach((product: any) => {
          product["checked"] = false;
          product["allImages"] = [];

          product['isMainImageAccessible'] = true;
          if (product["main_image"]) {
            product["allImages"].push(
              product["main_image"]
            );
          }
          if (product["product_images_gallery"]) {
            product["allImages"] = 
              product["product_images_gallery"]
          }
          product["allImages"] = product["allImages"].flat();
          product["product_feature"] = this.utils.compileMarkdown(
            product.feature
          );

          // product['main_image'] = this.assetBaseUrl + product.allImages[0];
          product['product_name'] = product.name;
          product['product_sku'] = product.sku;

          
          product['wishlisted'] = true;

        }); 
            this.productListings = this.productListings.filter(f => !f.height);

      this.productListings = payload.products;
      console.log(this.productListings,'PL')
      } else{
        this.totalProducts = 0;

        this.noProducts = true
      }
    this.productsLoading = false;
    // setTimeout(() => {
    //   if (this.masonry !== undefined) {
    //     this.masonry.reloadItems();
    //     this.masonry.layout();
    //   }
    // }, 0);

    }, err=>{
      this.productsLoading = false;
      this.noProducts = true;
      this.matSnackbar.open('Api error','x',{duration:4000})
    });
  }

 
  @HostListener("window:resize")
  onResize() {
    this.height = window.innerHeight;
    this.width = window.innerWidth;
    this.pageWidth = document.body.clientWidth;

  }
  panelStateChange() {
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 0);
  }

  getValue(key) {
    return key.replace(/[_-]/g, ' ').toUpperCase();
  }

  changeLayout() {
    if (this.gridView) {
      this.gridView = false
      this.goTableView();
    } else {
      this.gridView = true;
    }
  }

  ngOnInit() { 
    this.assetBaseUrl = this.env.assetSLBaseUrl;
    this.sorting.sortBy = 'asc';
    this.sorting.direction = 'recommended';
    this.sortType = 'recommended';
      this.getWishList();
    this.getDesignprojectDropdown();
    this.eventEmitterService.userChangeEvent
      .asObservable()
      .subscribe((user) => {
        if (user.id && user.email) {
        } else {
          this.productListings = [];
          // this.matDiaService.o
        }
      }); 

  }

  getDesignprojectDropdown() {
    this.api.getProjectDropdown().subscribe((res: any) => {
      this.projectOptions = res;
      this.projectOptions.forEach(f => {
        f['displayName'] = this.utils.formatRoomLabel(f);
      })
    });
  } 
 
  ngDoCheck(): void {

    // if (this.matDiaService.closeClicked) {
    //   this.matDiaService.closeClicked = false; 
    // }
  }
 
 
  openImageInNewTab(imageUrl: string) {
    window.open(imageUrl, "_blank");
  }

  openProductInNewTab(productUrl: string) {
    this.router.navigate([]).then(() => {
      window.open(`product/${productUrl}`, "_blank");
    });
  }
  plusSlides(event, n: number, row) {
    event.stopPropagation();
    this.showSlides((this.slideIndex += n), row);
  }

  showSlides(n, row, init?) { 
    let i;
    let slides = document.getElementsByClassName(
      "mySlides" + row
    ) as HTMLCollectionOf<HTMLElement>;
    if (!init) {
      if (n > slides.length) {
        this.slideIndex = 1;
      }
      if (n < 1) {
        this.slideIndex = slides.length;
      }
    } else {
      this.slideIndex = 1;
    }
    for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";
    }
    if (slides[this.slideIndex - 1]) {
      slides[this.slideIndex - 1].style.display = "block";
    }
  }
 

  hideIntercomIcon() {
    const interval = setInterval(() => {
      const intercom = document.getElementsByClassName(
        "intercom-lightweight-app"
      )[0];
      if (intercom) {
        intercom.classList.add("dn");
        clearInterval(interval);
      }
    }, 500);
    const intervalx = setInterval(() => {
      const intercomx = document.getElementsByClassName("intercom-app")[0];
      if (intercomx) {
        intercomx.classList.add("dn");
        clearInterval(intervalx);
      }
    }, 500);
  }

  
  goTableView() {
    this.gridView = false;
    setTimeout(() => {
      for (let i = 0; i < this.productListings.length; i++) {
        this.showSlides(0, i, true);
      }
    }, 0); 
  }  
    
  get getChecks() {
    return this.productListings.filter((f) => f.checked).length > 0;
  }

  removeFav(sku){ 
    const ind = this.productListings.findIndex(f=>f.sku===sku);
    if(ind>-1){
      this.productListings.splice(ind,1);
      this.totalProducts--;
      setTimeout(() => {
        if (this.masonry !== undefined) {
          this.masonry.reloadItems();
          this.masonry.layout();
        }
      }, 0);
  }
  }

  getProductData(event) {
    this.closeProductNav('');
    this.productDetails = event;
    this.paramSku = typeof event ==='string'? event : event.product_sku ? event.product_sku : event.sku;
    this.loadDetails = true;
    this.openProductNav();
  }

  openProductNav() {
    // this.router.navigate([], {
    //   queryParams: { sku: this.paramSku },
    //   queryParamsHandling: 'merge'
    // });
        this.router.navigate([]).then(() => {
      window.open(`/product/${this.paramSku}`);
    });
    // document.getElementById("productSidenav").style.width = "450px";
    //   document.getElementById('productSidenav').scrollTo({
    //       top: 0,
    //       left: 0,
    //       behavior: 'smooth'
    //     });
    // document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
    // this.api.isSideNavOpened = true;
  }

    closeProductNav(msg) {
    if (document.getElementById("productSidenav")) {
      this.loadDetails = false;
      document.getElementById("productSidenav").style.width = "0";
      document.body.style.backgroundColor = "white";
      if(msg!=='close' && msg){
        this.matSnackbar.open(msg, 'x', { duration: 3000 })
      } 
      this.api.isSideNavOpened = false;
    }
  } 
  
}